import React from 'react';
import { Spinner } from 'reactstrap';

const PageLoader = ({ isVisible, message = 'Loading...' }) => {
    if (!isVisible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                backdropFilter: 'blur(4px)',
            }}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '2rem',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                    textAlign: 'center',
                    maxWidth: '300px',
                    width: '90%',
                }}
            >
                <Spinner
                    color="primary"
                    size="lg"
                    style={{ marginBottom: '1rem' }}
                >
                    Loading...
                </Spinner>
                <div
                    style={{
                        fontSize: '1.1rem',
                        fontWeight: '500',
                        color: '#333',
                        marginBottom: '0.5rem',
                    }}
                >
                    {message}
                </div>
                <div
                    style={{
                        fontSize: '0.9rem',
                        color: '#666',
                    }}
                >
                    Please wait while we process your request...
                </div>
            </div>
        </div>
    );
};

export default PageLoader; 